import queryString from "query-string";
import { httpwmsapi } from "src/services";

// Action Types
export const Types = {
    MOVEMENT_SET_SUPER_STOCK_ADDRESSES: "movement/set/super_stock_addresses", //-
};

// Reducer
const initialState = {
    stocks: [],
};

// Action Creators
export default function reducer(state = initialState, action) {
    switch (action.type) {
        case Types.MOVEMENT_SET_SUPER_STOCK_ADDRESSES:
            return { ...state, stocks: action.payload };
        default:
            return state;
    }
}

export const Creators = {
    setSuperStockAddresses: value => ({ type: Types.MOVEMENT_SET_SUPER_STOCK_ADDRESSES, payload: value }),
    getSuperStockAddresses: (params) => {
        const qry = queryString.stringify(params, { arrayFormat: "index" });
        return new Promise((resolve, reject) => {
            httpwmsapi
                .get(`/v1/movimentacao/listar-enderecos-super-estoque?${qry}`, { timeout: 1000 * 60 * 10 })
                .then(({ data }) => resolve(data))
                .catch((error) => reject(error));
        });
    },
    deleteCachedSuperStockAddresses: (params) => {
        const qry = queryString.stringify(params, { arrayFormat: "index" });
        return new Promise((resolve, reject) => {
            httpwmsapi
                .delete(`/v1/movimentacao/listar-enderecos-super-estoque/cache?${qry}`, { timeout: 1000 * 60 * 10 })
                .then(({ data }) => resolve(data))
                .catch((error) => reject(error));
        });
    }
};